import type { WeekAvailability } from '../../../types/availability';
import { useTimetableVersionAvailabilitiesQuery } from '../../../types/planung-graphql-client-defs';
import { VERSION_RESOURCE_TYPE, VersionResourceKey } from '../utils/versionResourceType';

/** Verfügbarkeit einer Ressource in der Version; geladen werden alle Ressourcen dieser Art auf einmal. */
export const useVersionAvailability = (
  versionUuid: string | null | undefined,
  resource: VersionResourceKey,
  resourceUuid: string | undefined,
) => {
  const [{ data, fetching }, execute] = useTimetableVersionAvailabilitiesQuery({
    variables: { versionUuid: versionUuid ?? '', resourceType: VERSION_RESOURCE_TYPE[resource] },
    pause: !versionUuid,
  });
  const entry = data?.timetableVersionAvailabilities.find((entry) => entry.resourceUuid === resourceUuid);
  // nur die Wochentage: die Matrix erwartet die Form der Kanten-Eigenschaften
  const availability: WeekAvailability | undefined = entry && {
    mon: entry.mon,
    tue: entry.tue,
    wed: entry.wed,
    thu: entry.thu,
    fri: entry.fri,
    sat: entry.sat,
    sun: entry.sun,
  };
  return { availability, fetching, execute };
};
